import React from "react";
import Button from "../../components/button";
import PopUp, { openPopUp } from "../../components/popUp";
import TextField from "../../components/textField/textField";
import { useAppContext } from "../../context/appContext";
import { sha256 } from "../../utils/passwordUtils";
import SuccessPopUp from "./successPopUp";

export default function UpdatePasswordPopUp() {

    const {settingsController, sessionId} = useAppContext();

    const [error, setError]= React.useState<string | undefined>(undefined);

    const [oldPassword, setOldPassword] = React.useState("");
    const [newPassword, setNewPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");

    return <PopUp title="Change Password">
        <TextField label="Old Password" value={oldPassword} onChange={setOldPassword} type="password"/>
        <TextField label="New Password" value={newPassword} onChange={setNewPassword} type="password"/>
        <TextField label="Confirm Password" value={confirmPassword} onChange={setConfirmPassword} type="password"/>
        <p className="error">{error}</p>
        <Button onClick={async function() {
            if(confirmPassword !== newPassword) {
                setError("The new password and the confirmation do not match.");
                return;
            }
            if(newPassword.length < 8) {
                setError("The new password must be at least 8 characters long.");
                return;
            }
            const response = await settingsController.updatePassword(sessionId, {
                oldPassword: await sha256(oldPassword),
                newPassword: await sha256(newPassword)
            }).catch((e) => {
                console.log(e.response.status == 401);
                if(e.response.status == 401) {
                    setError("The old password is incorrect.");
                    return;
                }
                setError("An error occurred while changing the password.");
                return;
            });
            console.log(response);
            if(response) {
                openPopUp(<SuccessPopUp message="Your password has been updated successfully."/>);
            }
            
        }}>Update Password</Button>
    </PopUp>
}